import { TransactionResolvePagingParams, TRANSACTION_ROUTES } from './transaction.route';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TransactionComponent } from './transaction.component';
import { TransactionImportDialogComponent, TransactionUpdatePopupComponent } from './transaction-import-dialog.component';
import { TabRouteGuard } from '../../inventory-manager/tab-route.guard';
import { BmsjHipsterSharedModule } from '../../shared';
import { TruncateSpanComponent } from '../../shared/util/span-truncate/truncate-span.component';
import { SelectionCountComponent } from '../../shared/selection-count/selection-count.component';

const ENTITY_STATES = [
    ...TRANSACTION_ROUTES,
];

@NgModule({
    imports: [
        RouterModule.forChild(ENTITY_STATES),
        BmsjHipsterSharedModule,
        TruncateSpanComponent,
        SelectionCountComponent
    ],
    declarations: [
        TransactionComponent,
        TransactionImportDialogComponent,
        TransactionUpdatePopupComponent
    ],
    providers: [
        TransactionResolvePagingParams,
        TabRouteGuard
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InventoryManagerTransactionModule {}
